import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { solutionPages } from '../data/solutions';

const Solutions = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="relative py-24 md:py-28 bg-[--bg-primary] min-h-[70vh]">
      <div className="absolute top-0 left-0 right-0 section-divider" />

      <div ref={sectionRef} className="max-w-[1500px] mx-auto px-4 sm:px-6">
        <div
          className={`max-w-4xl mb-14 transition-all duration-700 ease-out ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <p className="section-eyebrow mb-4">Solutions</p>
          <h1 className="text-[clamp(2rem,4.2vw,4rem)] font-semibold text-[--text-primary] leading-[1.02]">
            AI solution tracks tailored
            <br />
            <span className="accent-wash">to real operating models.</span>
          </h1>
          <p className="mt-6 text-lg text-[--text-secondary] max-w-3xl">
            Explore solution tracks built for specific operating environments, each with workflows,
            outcomes, and proof points mapped to real execution.
          </p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {solutionPages.map((solution, index) => (
            <Link
              key={solution.slug}
              to={`/solutions/${solution.slug}`}
              className={`group block p-7 rounded-2xl soft-card hover:border-[--border-hover] transition-all duration-500 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${120 + index * 55}ms` }}
            >
              <p className="section-eyebrow mb-4">Solution</p>
              <h2 className="text-2xl font-semibold text-[--text-primary] group-hover:text-[--accent] transition-colors leading-tight mb-4">
                {solution.name}
              </h2>
              <p className="text-[--text-secondary] text-[0.98rem] leading-relaxed mb-6">
                {solution.shortDescription}
              </p>
              <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] font-mono text-[--text-secondary] group-hover:text-[--accent] group-hover:gap-3 transition-all">
                View solution
                <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
